/* eslint-disable no-console */
/* eslint-disable react/jsx-no-literals */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {
    useEffect, useState, useMemo, useCallback, useContext
} from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { Icon, InfoLabel, DateRangeField, ModalNextContext } from '@jutro/components';
import { AccountBillingDetailsService } from 'gw-capability-billing';
import { PolicyService } from 'gw-capability-policy';
import { ClaimService } from 'gw-capability-claim';
import { EnrollmentService } from 'gw-capability-policyenrollment';
import moment from 'moment';
import { AMPSubmissionDraftService } from 'gw-capability-quoteandbind';
import { DocumentService } from 'gw-capability-policydocument';
import { Currency as CurrencyField, LoaderExt } from 'gw-components-platform-react';
import { getNormalizedLOBName, isCapabilityEnabled } from '@xengage/gw-portals-config-js';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { LobIconUtil, LocalDateUtil } from '@xengage/gw-portals-util-js';
import { generateURL } from '@xengage/gw-portals-url-js';
import { useTranslator } from '@jutro/locale';
import appConfig from 'app-config';

import { Link } from '@jutro/router';
import styles from './LandingPage.module.scss';
import metadata from './LandingPage.metadata.json5';
import messages from './LandingPage.messages';
import  usecpmiAnalytics from '../../hooks/usecpmiAnalytics';
import useGoogleAnalytics from '../../hooks/useGoogleAnalytics';

import { AccountDropDownValues } from '../cpmi_SelectAccountDropDown';
import { PremiumAuditCEDocumentsTable } from 'cpmi-components-platform-react'

const NotificationDescription  = {
    BillingInvoiceReady: {
        name: "Invoice Ready",
        value: "An invoice has billed and is ready"
    },
    BillingInvoiceReminder : {
        name: "Invoice Reminder",
        value: "An invoice is unpaid and due soon"
    },
    NOC: {
        name: "Notice of Cancellation",
        value: "A Notice of Cancellation has been generated"
    },
    PayrollReport: {
        name: "Payroll Reminder",
        value: "A payroll report is unfinished and due soon"
    },
    Paperless: {
        name: "Paperless",
        value: "Paperless Notification"
    },
    ClaimsUpdate: {
        name: "Claims Update",
        value: "A claim has updated with change to status, reserves or maximum medical improvement"
    },
    NewDocument: {
        name: "New Document",
        value: "An account/policy document has been posted"
    },
    LossRunSubscription: {
        name: "Loss Run Subscription (PDF)",
        value: "Receive loss run report while at least one policy is in force"
    },
    LossRunSubscriptionXL: {
        name: "Loss Run Subscription (EXCEL)",
        value: "Receive loss run report while at least one policy is in force"
    }
};
const getCellType = (rowData) => {
    const activePeriod = _.first(rowData.periods);
    const lineOfBusiness = activePeriod.lines.length > 1
        ? activePeriod.lines.map((line) => line) : _.first(activePeriod.lines);
    const icon = activePeriod.lines.length > 1 ? 'mi-unarchive' : LobIconUtil.getMaterialIcon(lineOfBusiness);

    return <Icon icon={icon} title={lineOfBusiness} key={lineOfBusiness} />;
};

const isPolicyActive = (periods) => {
    const currentRenewed = periods.length > 1;
    const activePeriod = _.first(periods);

    return new Date(activePeriod.effective).getTime() < new Date().getTime() && !currentRenewed;
};

const shouldRenewalNotificationShow = (accountPolicyData) => accountPolicyData.some((policy) => policy.periods.length > 1);

const getCellStatus = (rowData) => {
    if (isPolicyActive(rowData.periods)) {
        return <InfoLabel type="success" size="medium" message={messages.statusActive} />;
    }

    return <InfoLabel type="info" size="medium" message={messages.statusRenewed} />;
};

const getCellPolicy = (rowData) => {
    const activePeriod = _.first(rowData.periods);
    const periodWithIDCard = rowData.periods.find((policy) => policy.idCardPublicID);

    return (
        <Link
            className={styles.link}
            to={{
                pathname: `/account-policy-details/${activePeriod.policyId}`,
                productCode: activePeriod.lines[0],
                idCard: periodWithIDCard ? {
                    idCardSessionID: _.get(periodWithIDCard, 'idCardSessionID'),
                    idCardPublicID: _.get(periodWithIDCard, 'idCardPublicID')
                } : null
            }}
        >
            {activePeriod.policyId}
        </Link>
    );
};

const getCellEffective = (rowData, rowIndex) => {
    const activePeriod = _.first(rowData.periods);
    const effectiveDate = new Date(activePeriod.effective);
    const expirationDate = new Date(activePeriod.expiration);
    const periodValue = {
        startDate: {
            year: effectiveDate.getFullYear(),
            month: effectiveDate.getMonth(),
            day: effectiveDate.getDate()
        },
        endDate: {
            year: expirationDate.getFullYear(),
            month: expirationDate.getMonth(),
            day: expirationDate.getDate()
        },
    }

    return (
        <DateRangeField
            id={`effectiveDate_${rowIndex}`}
            value={periodValue}
            hideLabel
            readOnly
        />
    );
};

const getCellClaim = (rowData) => {
    const activePeriod = _.first(rowData.periods);

    const redirectPath = {
        pathname: '/fnol-select-policy',
        state: {
            policyNumber: activePeriod.policyId,
            redirectPath: '/home',
            claimData: { lossDate: new Date() },
        }
    };

    return (
        <Link to={redirectPath} className={styles.link}>
            {messages.fileClaim}
        </Link>
    );
};

const getCellPremium = (rowData, rowIndex) => {
    const activePeriod = _.first(rowData.periods);

    return (
        <CurrencyField
            id={`premium_${rowIndex}`}
            value={activePeriod.premium}
            dataType="object"
            readOnly
            hideLabel
        />
    );
};

const { capabilitiesConfig } = appConfig;

function LandingPage(props) {
    const auth = useAuthentication();
    const translator = useTranslator();
    const ModalNext = useContext(ModalNextContext);
    const [accountBillingData] = useState([]);
    const [accountPolicyData] = useState([]);
    const { authHeader } = useAuthentication();
    const [accountData] = useState([]);
    const [isLoading, setLoadingState] = useState(false);
    const [isPolicyUser, setPolicyUser] = useState(false);
    const [isBillingUser, setBillingUser] = useState(false);
    const [isPayrollUser, setPayrollUser] = useState(false);
    const [isClaimUser, setClaimUser] = useState(false);
    const [isAdminUser, setAdminUser] = useState(false);
    const [isOrgAdminUser, setOrgAdminUser] = useState(false);
    const [optinRadioValue, setOptinRadioValue] = useState();
    const [optinRadioDisabled, setOptinRadioDisabled] = useState(true);
    const [policySnapshotData, setPolicySnapshotData] = useState([]);
    const [billingSnapshotData, setBillingSnapshotData] = useState({});
    const [userSnapshotData, setUserSnapshotData] = useState({});
    const [trackEvent] = usecpmiAnalytics();
    const [trackGAPageView] = useGoogleAnalytics();
    const [currentAccountNumber,setCurrentAccountNumber]=useState()
    const [openClaims, setOpenClaims] = useState();
    const [accountNameTitle,setAccountNameTitle] = useState(undefined);
    const [showHideBillingBlock, setShowHideBillingBlock] = useState();
    const [dropdownMultiStreamData, setDropdownMultiStreamData] = useState([]);
    const [accountsData,setAccountsData] =useState([]);
    const [billingDetailsVisible, setBillingDetailsVisible] =useState(false);
    const [noBillingData, setNoBillingData] =useState(false);
    const [claimDataVisible, setClaimDataVisible] =useState(false);
    const [policyDataLoaded, setPolicyDataLoaded] =useState(false);
    const [auditStatus, setAuditStatus] = useState('Loading...')
    const [highlightStatus, setHighlightStatus] = useState(false)

    useEffect(()=>{
        trackGAPageView("/Home","Home");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    const checkAuthorityLevel = useCallback(() => {
        const {grantedAuthorities} = auth.userInfo;
        const authorityLevel = [];

        function hasAuthority(authLevel, val) {
            const result = authLevel.findIndex(item => val.toUpperCase() === item.toUpperCase());

            if (result !== -1) {
                return true;
            }

            return false;
        }

        for (const authority of grantedAuthorities) {
            const authorityRegex = /^guidewire\.edge\.(.*)\.(.*)\.(.*)$/g;
            const match = authorityRegex.exec(authority);

            authorityLevel.push(match[3]);
        }

        if (
            hasAuthority(authorityLevel,'USERADMIN')
        ){
            setOrgAdminUser(true);
        }

        if (
            hasAuthority(authorityLevel,'USERADMIN') ||
            hasAuthority(authorityLevel,'ALL')
        ) {
            setAdminUser(true);
        }

        if (
            hasAuthority(authorityLevel,'CLAIM')             ) {
            setClaimUser(true);
        }

        if (
            hasAuthority(authorityLevel,'POLICY')
        ) {
            setPolicyUser(true);
        }

        if (
            hasAuthority(authorityLevel,'PAYROLL')
        ) {
            setPayrollUser(true);
        }

        if (
            hasAuthority(authorityLevel,'BILLING')
        ) {
            setBillingUser(true);
        }

    }, [auth]);


    const handleValueChange = async (accountNumber) => {

        if(accountNumber !== currentAccountNumber){
            setCurrentAccountNumber(accountNumber);
            setBillingDetailsVisible(false)
            setClaimDataVisible(false)
            setOptinRadioDisabled(true)
            setOpenClaims(0)
            setPolicySnapshotData([])
            setPolicyDataLoaded(false)
            setNoBillingData(false)
            setHighlightStatus(false)
            setAuditStatus('Loading...')

            totalClaims(accountNumber)

            // might need to add a change here
            PolicyService.getPremiumAuditStatusesByAccountNumber(accountNumber, authHeader).then((statuses) => {
                console.log(statuses)

                if (statuses && statuses.filter(s =>
                    s.status &&s.status.trim().toLowerCase() === 'closeout'
                    && s.detailedStatus && s.detailedStatus.trim().toLowerCase() === 'billed'
                ).length > 0){
                    setAuditStatus('Estimated Audit')
                    setHighlightStatus(true)
                }
                else {
                    setAuditStatus('In Good Standing')
                }
            })

            EnrollmentService.getPaperlessOptinSnapshot(accountNumber, authHeader).then((response) => {
                if (response === false) {
                    setOptinRadioValue('receivemail');
                }
                else {
                    setOptinRadioValue('donotreceivemail');
                }

                setOptinRadioDisabled(false)

            });

            PolicyService.getAccountPolicySummaries_Ext(accountNumber, authHeader).then((res) => {
                const filteredResponse = res.filter(item => item.displayStatus === 'In Force' || item.displayStatus === 'Pending Cancellation');

                setPolicySnapshotData(filteredResponse)
            }).catch(() => console.log(`There was an issue retrieving account ${  accountNumber  } policy snapshots.`))
            .finally(() =>
                setPolicyDataLoaded(true)
            )
        }
    }

    const getAccountName = useCallback((value) => {
        setAccountNameTitle(value[0].name.split('  ')[1]);
    }, [])

    // Actually get the policies and account data. Accounts are in the user already. PC grabs all policies connected to a user
    const getSnapshotDetails = useCallback(async () => {
        setLoadingState(true);

        const objAccountArray = EnrollmentService.getUser(auth.userInfo.email, authHeader)
            .then((resultObjectAccountDetails) => {
                setAccountsData(resultObjectAccountDetails);
            });

        const userDetailsPromise = EnrollmentService.getUserOptinsSnapshot(auth.userInfo.email, authHeader).then(
            (userDetailsResponse) => {
                setUserSnapshotData(userDetailsResponse);

                if (userDetailsResponse.paperlessOptInSelected) {
                    setOptinRadioValue('donotreceivemail');
                }
            });

        Promise.all([
            objAccountArray,
            userDetailsPromise
        ])
            .then(() => {
                setLoadingState(false);
            })
            .catch(() => {
                setLoadingState(false);
            });
    }, [auth.userInfo.email, authHeader]);

    const functionLandingData = useCallback(async () => {
        if (!authHeader) return;
        const filteredPolicySnapshots = policySnapshotData.filter((item) => item.accountNumber === currentAccountNumber);

        if (currentAccountNumber !== undefined && filteredPolicySnapshots.length !== 0) {
            try {
                const response = await AccountBillingDetailsService.getSelectedAccountBillingSnapshot_Ext(currentAccountNumber, authHeader);

                if (filteredPolicySnapshots.length !== 0) {
                    setBillingSnapshotData(response);
                    setShowHideBillingBlock(response.invoiceStreamCount);

                    const invoiceSTreamsArray = [];

                    // eslint-disable-next-line array-callback-return
                    response.allInvoiceStreamDetails.map((itemIndex) => {
                        invoiceSTreamsArray.push({
                            name: itemIndex.displayName,
                            code: itemIndex.internalId
                        });
                    });
                    setDropdownMultiStreamData(invoiceSTreamsArray);
                    setBillingDetailsVisible(true);
                }
            } catch (err) {
                console.warn('[LandingPage] getSelectedAccountBillingSnapshot_Ext failed', err);
                setNoBillingData(true);
            }
        } else if (policyDataLoaded && filteredPolicySnapshots.length === 0) {
            setNoBillingData(true);
        }
    }, [policySnapshotData, currentAccountNumber, authHeader, policyDataLoaded]);

    useEffect(() => {
        checkAuthorityLevel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        functionLandingData().catch((err) => {
            console.warn('[LandingPage] functionLandingData failed', err);
        });
    }, [authHeader, currentAccountNumber, policySnapshotData, policyDataLoaded, functionLandingData])

    useEffect(() => {
        getSnapshotDetails();
    },[getSnapshotDetails, isOrgAdminUser])

    const aggregateBilling = useCallback((invoices) => {
        if (invoices.length === 0) {
            return null;
        }

        let total = 0;
        let due = new Date(invoices[0].dueDate);

        _.each(invoices, (invoice) => {
            total += invoice.amountDue.amount;

            const newDue = new Date(invoice.dueDate);

            if (newDue.getTime() < due.getTime()) {
                due = newDue;
            }
        });

        return {
            amountDue: {
                amount: total,
                currency: invoices[0].amountDue.currency
            },
            earliestDue: due
        };
    }, []);

    const getMyBalanceOverDueAndCurrentData = useCallback(
        (invoiceStatus) => {
            if (accountBillingData.activeInvoices) {
                const invoices = accountBillingData.activeInvoices;

                return aggregateBilling(
                    invoices.filter((invoice) => invoice.invoiceStatus === invoiceStatus)
                );
            }

            return null;
        },
        [accountBillingData.activeInvoices, aggregateBilling]
    );



    const getBalanceData = useCallback(() => {
        const overdue = getMyBalanceOverDueAndCurrentData('due');
        const current = getMyBalanceOverDueAndCurrentData('billed');

        if (overdue && current) {
            return {
                amount: current.amountDue.amount + overdue.amountDue.amount,
                currency: current.amountDue.currency
            };
        }

        if (overdue || current) {
            return (overdue || current).amountDue;
        }

        return null;
    }, [getMyBalanceOverDueAndCurrentData]);

    const readValue = useCallback(
        (id, path) => {
            if (path === 'balanceAmount') {
                return getBalanceData();
            }

            if (path === 'overDueAmount') {
                return _.get(getMyBalanceOverDueAndCurrentData('due'), 'amountDue');
            }

            if (path === 'currentAmount') {
                return _.get(getMyBalanceOverDueAndCurrentData('billed'), 'amountDue');
            }

            if (path === 'dueDate') {
                return _.get(getMyBalanceOverDueAndCurrentData('due'), 'earliestDue');
            }

            return _.get(accountBillingData, path);
        },
        [accountBillingData, getBalanceData, getMyBalanceOverDueAndCurrentData]
    );

    const policyWithIDCard = useMemo(() => {
        let periodWithIDCard;

        accountPolicyData.some((policyData) => policyData.periods.some((period) => {
                if (period.idCardPublicID) {
                    periodWithIDCard = period;

                    return true;
                }

                return false;
            }));

        return periodWithIDCard;
    }, [accountPolicyData]);

    const getIDCardQuickLink = useCallback(async () => {
        if (!policyWithIDCard) {
            return;
        }

        await DocumentService.downloadPolicyDocument(
            policyWithIDCard.idCardPublicID,
            policyWithIDCard.idCardSessionID
        );
    }, [policyWithIDCard]);

    const automatedPaymentURL = useMemo(() => {
        const billingID = _.get(accountBillingData, 'manualPayPaymentGroups[0]');

        if (!billingID) {
            return undefined;
        }

        return `billing-summary/${billingID}`;
    }, [accountBillingData]);

    const firstAccountSummaryDefined = useMemo(() => accountData.length <= 1 && !_.isEmpty(accountData), [accountData]);

    const mailToTrigger = useCallback((event, email) => {
        event.preventDefault();
        window.location = `mailto:${email}`;
    }, []);

    const claimCapabilityCheck = useMemo(() => isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'fnol' }), []);

    const onQuoteQuickLinkClick = useCallback(
        (lob) => () => {
            const accountSummary = accountData[0];
            const submission = {
                baseData: {
                    productCode: lob,
                    accountHolder: accountSummary,
                    accountNumber: accountSummary.accountNumber,
                    policyAddress: accountSummary.accountContact.primaryAddress,
                    periodStartDate: LocalDateUtil.today()
                }
            };

            AMPSubmissionDraftService.createForAccount(submission, authHeader).then(
                (savedSubmission) => {
                    const token = authHeader?.Authorization?.replace(/^Bearer\s+/i, '')?.trim();
                    const hash = token ? `#t=${encodeURIComponent(token)}` : '';
                    const { url } = appConfig.quoteAndBuy;
                    const location = `${url}/quote-${getNormalizedLOBName(lob)}`;
                    const params = {
                        quoteID: savedSubmission.quoteID,
                        postalCode: savedSubmission.baseData.policyAddress.postalCode,
                        sessionUUID: savedSubmission.sessionUUID,
                        accountNumber: savedSubmission.baseData.accountNumber,
                    };

                    window.location = generateURL(location, params) + hash;
                }
            );
        },
        [accountData, authHeader]
    );

    const getCellAgent = useCallback(
        (rowData) => (
                <React.Fragment>
                    <Link className={styles.link} onClick={(e) => mailToTrigger(e, rowData.producerContact.email)}>
                        {rowData.producerContact.displayName}
                    </Link>
                    <br />
                    {rowData.producerContact.phoneNumber ? (
                        <span>
                            {translator(messages.policyDetailsTel)}
                            {rowData.producerContact.phoneNumber}
                        </span>
                    ) : (
                        ''
                    )}
                </React.Fragment>
            ),
        [mailToTrigger, translator]
    );

    const getTableOverrides = useCallback(() => ({
            typeColumn: { renderCell: getCellType },
            statusColumn: { renderCell: getCellStatus },
            policyColumn: { renderCell: getCellPolicy },
            effectiveColumn: { renderCell: getCellEffective },
            premiumColumn: { renderCell: getCellPremium },
            fileAClaimColumn: {
                visible: claimCapabilityCheck,
                renderCell: getCellClaim
            },
            agentColumn: {
                visible: accountData.length > 1,
                renderCell: getCellAgent
            }
    }), [accountData, claimCapabilityCheck, getCellAgent]);

    const makeAPaymentLink=useCallback(()=>{
        trackEvent("Make a Payment","/make-payment");

        const getDueAmount = ()=>{
            if(accountBillingData.activeInvoices){
                const {activeInvoices} = accountBillingData;
                const sum = activeInvoices.reduce((accumulator, object) => accumulator + object.amountDue.amount, 0);

                return sum;
            }

            return '0.00';
        };

        const {history} = props;

        return history.push({
            pathname: '/make-payment',

            state: {
                redirectPath: '/home',
                dueAmount:getDueAmount(),
                accountNumber:accountData[0]?.accountNumber,
                page:'LandingPage',
                dropdownMultiStreamData,
                accountsData
            },

        });

    }, [accountBillingData, accountData, accountsData, dropdownMultiStreamData, props, trackEvent]);

    const onFileClaimClick=useCallback(() => {

        const {history} = props;

        return history.push({
            pathname: '/fnol-select-policy',
            state: {
                redirectPath: '/select-policy',
                page:'LandingPage',
                claimData: { lossDate: new Date() }
            }
        });
    },[props])

    const onReportPayrollClick=useCallback(() => {

        const {history} = props;

        return history.push({
            pathname: '/payroll-reporting/list/report',
            state: {
                redirectPath: '/home',
                page:'LandingPage'
            }
        });
    },[props])

    const onCoiClick= useCallback(()=> {
        const {history} = props;

        return history.push({
            pathname: '/certificate',
            state: {
                redirectPath: '/home',
            }
        });
    },[props])

    const onAccountClick = useCallback(()=> {
        trackEvent("View Account","/userprofile");

        const {history} = props;

        return history.push({
            pathname: '/userprofile',
            state: {
                redirectPath: '/home',
            }
        });
    },[props, trackEvent])

    const onMyProfileClick = useCallback(()=> {
        trackEvent("My Profile","/myprofilepage");

        const {history} = props;

        return history.push({
            pathname: '/myprofilepage',
            state: {
                redirectPath: '/home',
            }
        });
    },[props, trackEvent])

    const handleLinkClick = useCallback(
        (event) => {
            const { history } = props;

            return history.push(event.path);
        },
        [props]
    );

    const showBillingSection = useMemo(() => isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'billing' }), []);

    const getAccountInfo = () => {
        if (currentAccountNumber === undefined){
            return <div className={styles.billingSnapshotData}><div>No billing data to display</div></div>
        }

        return (
            <div className={styles.billingSnapshotData}>
                <div>Billing Account: {policySnapshotData && policySnapshotData.length > 0 ? policySnapshotData[0].accountNumber : '' }</div>
                <div>Status: {billingSnapshotData.basicDetails && billingSnapshotData.basicDetails.isDelinquent ? 'Delinquent' : 'In Good Standing'}</div>
                {showHideBillingBlock === 1 && <div>Automatic Payment: {billingSnapshotData?.allInvoiceStreamDetails !== undefined && billingSnapshotData?.allInvoiceStreamDetails?.length > 0 && billingSnapshotData.allInvoiceStreamDetails[0].enrolledForAutomticPayment ? 'Enrolled' : 'Not Enrolled'}</div>}
            </div>
        )
    }

    const getCurrentDueAmount=(amount)=>amount.toLocaleString("en-US", {style:"currency", currency:"USD"});

    const getBillingDueInfo = useCallback(() => {
        const isPastdue = billingSnapshotData.basicDetails && billingSnapshotData.basicDetails.pastDue.amount > 0;
        let billedInvoices = [];
        const invoiceStream = billingSnapshotData.invoiceStreamDetails;

        if (invoiceStream && invoiceStream.invoiceSummary && invoiceStream.invoiceSummary.length > 0) {
            invoiceStream.invoiceSummary.forEach((item)=>{
                // item.dueDate = new Date(item.dueDate);
                if (item.invoiceStatus === 'billed' && item.paidStatus === 'unpaid') {

                    billedInvoices.push(item);
                }
            });
        }

        const pastDueData = (
            <div className={styles.pastDueData}>
                <div className={styles.currentDueSpace}>Past Due:</div>
                <div className={styles.currentDueSpace}>Due Immediately</div>
                <div className={styles.currentDueSpace}>{billingSnapshotData.basicDetails ? getCurrentDueAmount(billingSnapshotData.basicDetails.pastDue.amount) : ''}</div>
            </div>
        )

        if (billedInvoices.length > 4) {
            billedInvoices = billedInvoices.slice(0, 4);
        }

        const mapData = billedInvoices.map((item, index) => (
            <div key={index} className={styles.currentDue}>
                <div className={styles.currentDueSpace}>Current Due:</div>
                <div className={styles.currentDueSpace}>{moment(item.dueDate).format('MM/DD/YYYY')}</div>
                <div className={styles.currentDueSpace}>{getCurrentDueAmount(item.amountDue.amount)}</div>
            </div>
        ))

        const currentDueInfo =   (
            <div className={styles.currentDue}>
                <div className={styles.currentDueSpace}>Current Due:</div>
                <div className={styles.DueSpace} />
                <div className={styles.DueSpace}>$0.00</div>

            </div>
        )

        return(
            <React.Fragment>
                {showHideBillingBlock === 1 && isPastdue ? pastDueData : ''}
                {billedInvoices.length>0 && showHideBillingBlock === 1?mapData:showHideBillingBlock === 1 && currentDueInfo}
            </React.Fragment>
        )

    }, [billingSnapshotData.basicDetails, billingSnapshotData.invoiceStreamDetails, showHideBillingBlock])

    const getLoader = () => <div className={styles.billingSnapshotData}><div>Loading...</div></div>

    const getBillingLoader = () => noBillingData ? <div className={styles.billingSnapshotData}><div>No Billing Data Available</div></div> : getLoader()

    const getNotificationInfo = () => {
        const optIns = userSnapshotData.optIns || [];
        const mapData = optIns.filter((item)=>item?.itemName!=="ClaimsUpdate" && item?.itemName!=="PremiumAudit").map((item) => (
            <div key={item.itemName} className={styles.enrollmentListItem}>
                <div style= {{width: "60%"}} className={`${styles.enrollmentItem  } ${  styles.enrollmentText}`} >
                    {NotificationDescription[item.itemName] ? NotificationDescription[item.itemName].name: ''}
                </div>
                <div className={styles.enrollmentItem}>
                    {item.selected ? 'Enrolled': 'Not Enrolled'}
                </div>
            </div>
        ));

        return(
            <div>{mapData}</div>
        );
    };

    const totalClaims = useCallback((accountNumber) => {
        const query = {
            claimStates: ['open']
        };

        if (accountNumber !== undefined) {
            const claimsPromise = ClaimService.getClaimSummaries(query, {}, accountNumber, authHeader);

            claimsPromise.then((response) => {
                    setOpenClaims(response.items.length)
                    setClaimDataVisible(true)
                }
            )
        }

    }, [authHeader])

    const onOptinChange = (selectedRadioOptin) => {
        const accountNumber = currentAccountNumber

        if(selectedRadioOptin === 'receivemail'){
            ModalNext.showConfirm({
                title: 'Paperless Account Opt-In',
                message: 'Click confirm if you wish to receive the documents associated with this account in the mail.',
                confirmButtonText: 'Confirm'
            }).then((results) => {
                if (results === 'confirm') {

                    setLoadingState(true);
                    EnrollmentService.updatePaperlessOptinSnapshot(auth.userInfo.email,false,accountNumber,authHeader)

                        .then(()=>{
                            setOptinRadioValue(selectedRadioOptin);

                            ModalNext.showAlert({
                                title: 'Successfully updated.',
                                message: '',
                                status: 'info'
                            });
                        }).catch(() => {
                            ModalNext.showAlert({
                                title: 'There was an error',
                                message: 'Please try again later',
                                status: 'error',
                                icon: 'mi-error-outline'
                            });
                        }).finally(() => {
                            setLoadingState(false);
                        });
                }
            }, _.noop);
        }

        if(selectedRadioOptin === 'donotreceivemail'){
            ModalNext.showConfirm({
                title: 'Paperless Account Opt-In',
                message: 'Click confirm if you no longer wish to receive the documents associated with this account in the mail except the documents required by law.',
                confirmButtonText: 'Confirm'
            }).then((results) => {
                if (results === 'confirm') {

                    setLoadingState(true);
                    EnrollmentService.updatePaperlessOptinSnapshot(auth.userInfo.email,true,accountNumber,authHeader)
                        .then(()=>{

                            setOptinRadioValue(selectedRadioOptin);
                            ModalNext.showAlert({
                                title: 'Successfully updated.',
                                message: '',
                                status: 'info'
                            });
                        }).catch(() => {
                            ModalNext.showAlert({
                                title: 'There was an error',
                                message: 'Please try again later',
                                status: 'error',
                                icon: 'mi-error-outline'
                            });
                        }).finally(() => {
                            setLoadingState(false);
                        });
                }
            }, _.noop);
        }
    };



    const getPolicyLob = (item) =>item.lineOfBusinessName==='Workers\' Comp Line (v7)'?'Workers\' Compensation':item.lineOfBusinessName?.split(' (v7)')[0];
    const getPolicyStatus = (item) =>{
        if(item.displayStatus === 'Pending Cancellation'){
            return (<span style={{color:"#ed1c24"}}>{item.displayStatus}</span>)
        }

        return item.displayStatus
    };
    const getPolicyNumber = (item) =>{
        const periodWithIDCard = item.termPublicId;

        return (
            <Link
                className={styles.link}
                onClick={() =>  trackEvent("View Policy Details","/account-policy-details")}
                to={{
                    pathname: `/account-policy-details/${item.policyNumber}`,
                    productCode: item.lineOfBusinessCode,
                    state:{term:item.termNumber,
                        policyNumber:item.policyNumber,
                        isODSPolicy:item.isODSPolicy,
                        effective:LocalDateUtil.toMidnightDate(item.effective),
                        expiration:LocalDateUtil.toMidnightDate(item.expiration),},
                    idCard: periodWithIDCard ? {
                        idCardSessionID: _.get(periodWithIDCard, 'idCardSessionID'),
                        idCardPublicID: _.get(periodWithIDCard, 'idCardPublicID')
                    } : null
                }}
            >
                {item.policyNumber}
            </Link>
        );
    };
    const getPolicyEffective = (item) =>{
        const effectiveDate = moment(item.effective).format('MM/DD/YYYY')
        const expirationDate = moment(item.expiration).format('MM/DD/YYYY')

        return `${effectiveDate} - ${expirationDate}`;
    };
    const gotoClaims = () =>{
        const { history } = props;

        return history.push({
            pathname: `/claims`
        });
    }


    const handleLandingPageImgClick = (e) => {
        e.preventDefault();
        window.open(`https://www.linkedin.com/company/copperpoint?nocache=${(new Date()).getTime()}`, '_blank');
    }

    if (isLoading && billingSnapshotData.length === 0 || accountsData.length ===0) {
        return <LoaderExt loaded={!isLoading} />;
    }

    const getDefaultTest = () => policyDataLoaded ? "No Policies Found" : "Loading..."

    const override = {
        '@field': {
            phone: {
                labelPosition: 'left'
            }
        },
        adminQuickLinks: {
            visible: isOrgAdminUser
        },
        nonAdminQuickLinks: {
            visible: !isOrgAdminUser
        },
        EnrollmentContainer: {
            visible: isOrgAdminUser
        },
        PaperlessElectionContainer: {
            visible: isOrgAdminUser
        },
        pageContainer: {
            className: isOrgAdminUser ? '' : 'pageContainerPage'
        },
        pageTitle: {
        content: `Welcome, ${accountNameTitle??accountData[0]?.accountContact?.displayName}`,

        },
        leftWrapper: {
            className: isOrgAdminUser ? 'dividerAdmin' : 'divider'
        },
        cpmiLandingPage: {
            visible: !isOrgAdminUser,
            onClick: (e) => {
                handleLandingPageImgClick(e);
            },
            sizes: "(max-width: 500px) 360px, 1000px",
        },
        snapshotDetails: {
            visible: isOrgAdminUser
        },
        policyDetailsTable: {
            data: policySnapshotData,
            noDataText: getDefaultTest()
        },
        accountInfo: {
            visible: billingDetailsVisible,
            content: getAccountInfo(),
        },
        billingDueInfo: {
            visible: billingDetailsVisible,
            content: getBillingDueInfo(),
        },
        openClaimsContainer: {
            visible: claimDataVisible
        },
        claimLoading: {
            visible: !claimDataVisible,
            content: getLoader(),
        },
        billingLoading: {
            visible: !billingDetailsVisible,
            content: getBillingLoader(),
        },
        snapshotClaimsCount: {
            content:openClaims
        },
        optinRadiofield: {
            value: optinRadioValue,
            disabled: optinRadioDisabled
        },
        notificationInfo: {
            content: getNotificationInfo(),
        },
        myBalanceOverdueAmount: {
            visible: !_.isEmpty(getMyBalanceOverDueAndCurrentData('due'))
        },
        myBalanceCurrentAmount: {
            visible: !_.isEmpty(getMyBalanceOverDueAndCurrentData('billed'))
        },
        dueDateContainer: {
            visible: !_.isEmpty(getMyBalanceOverDueAndCurrentData('due'))
        },
        dueDateLabel: {
            visible: !_.isEmpty(getMyBalanceOverDueAndCurrentData('billed'))
        },
        payNowButton: {
            visible: firstAccountSummaryDefined
        },
        mediaSidebar: {
            showContact: accountData.length = 1
        },
        cpmilandingpage: {
            srcSet: "branding/cpmi_landing_image.jpg 360w, branding/cpmi_landing_image.jpg 1000w",
            sizes: "(max-width: 500px) 360px, 1000px"
        },
        policiesTable: {
            data: accountPolicyData
        },
        printAnIDCardLink: {
            visible: !_.isNil(policyWithIDCard),
            href: '#',
            onClick: e => {
                e.preventDefault();
                getIDCardQuickLink();
            }
        },
        setupAutomatedPaymentsLink: {
            onClick: {
                callback: 'handleLinkClick',
                callbackProps: {
                    path: automatedPaymentURL,
                }
            },
            visible: !!automatedPaymentURL && showBillingSection
        },
        getAPAQuote: {
            onClick: onQuoteQuickLinkClick('PersonalAuto'),
            visible: appConfig.quoteAndBuy.ampQuote && firstAccountSummaryDefined
        },
        getAHOQuote: {
            onClick: onQuoteQuickLinkClick('Homeowners'),
            visible: appConfig.quoteAndBuy.ampQuote && firstAccountSummaryDefined
        },
        renewalNotification: {
            visible: shouldRenewalNotificationShow(accountPolicyData)
        },
        fileAClaimLink: {
            visible: claimCapabilityCheck
        },
        tileGroupContainer: {
            visible: showBillingSection
        },
        makeAPaymentLink: {
            visible: showBillingSection
        },
        certificateInsuranceCard:{
            visible: isPolicyUser || isAdminUser
        },
        makePaymentCard: {
            visible: isBillingUser || isAdminUser
        },
        reportPayrollCard: {
            visible: isPayrollUser || isAdminUser
        },
        fileClaimCard:{
            visible: isClaimUser || isAdminUser
        },
        availableProducerCode:{
            getAccountName,
            page:"LandingPage",
            authHeader
        },
        premiumAuditStatusName: {
            content: auditStatus,
            className: highlightStatus ? 'red' : ''
        },

        ...getTableOverrides()
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveValue: readValue,
        resolveCallbackMap: {
            handleLinkClick,
            handleLandingPageImgClick,
            onFileClaimClick,
            makeAPaymentLink,
            onReportPayrollClick,
            onCoiClick,
            onAccountClick,
            onMyProfileClick,
            onOptinChange,
            getPolicyLob,
            getPolicyStatus,
            getPolicyNumber,
            getPolicyEffective,
            gotoClaims,
            handleValueChange,


        },
        resolveComponentMap:{

            AccountDropDownValues,
            PremiumAuditCEDocumentsTable
        }
    };

    return <MetadataContent uiProps={metadata.pageContent} overrideProps={override} {...resolvers} />;
}

export default withRouter(LandingPage);
